import React, { useState } from "react";

const EventSupportRequest = () => {
  const [formData, setFormData] = useState({
    organizationName: "",
    contactName: "",
    email: "",
    phone: "",

    eventName: "",
    website: "",

    startDate: "",
    endDate: "",

    venue: "",
    city: "",
    state: "",

    attendance: "",

    mangaLibrary: false,
    arcadeMachines: false,
    matsuriActivities: false,
    educationalPanels: false,
    workshops: false,
    tableRentals: false,

    spaceAvailable: "",
    notes: "",
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");

    try {
      const response = await fetch("/api/event-support", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to submit request");
      }

      setSubmitted(true);
    } catch (err) {
      setError(
        err?.message || "Unable to submit request. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <main className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-24 max-w-3xl text-center">
          <h1 className="text-5xl font-display mb-6">
            Request Submitted
          </h1>

          <p className="text-xl text-muted-foreground">
            Thank you for contacting us. A member of our team will review
            your request and reach out as soon as possible.
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className="bg-background min-h-screen">
      <section className="py-24 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4 max-w-4xl text-center">
          <h1 className="text-5xl md:text-7xl font-display mb-6">
            Event Support Request
          </h1>

          <p className="text-xl opacity-90">
            Interested in our manga library, arcade collection, or event
            equipment rentals? Tell us about your event and we'll get in touch.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4 max-w-5xl">

          <form
            onSubmit={handleSubmit}
            className="bg-card border rounded-3xl p-8 md:p-12 shadow-sm"
          >

            {error && (
              <div className="mb-8 p-4 rounded-xl border border-red-500 text-red-500">
                {error}
              </div>
            )}

            <div className="mb-8">
              <h2 className="text-3xl font-display mb-6">
                Contact Information
              </h2>

              <div className="grid md:grid-cols-2 gap-6">

                <div>
                  <label className="block mb-2 font-medium">
                    Organization Name *
                  </label>

                  <input
                    type="text"
                    name="organizationName"
                    value={formData.organizationName}
                    onChange={handleChange}
                    required
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    Contact Name *
                  </label>

                  <input
                    type="text"
                    name="contactName"
                    value={formData.contactName}
                    onChange={handleChange}
                    required
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    Email Address *
                  </label>

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    Phone Number
                  </label>

                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

              </div>
            </div>

            <div className="mb-8">
              <h2 className="text-3xl font-display mb-6">
                Event Information
              </h2>

              <div className="grid md:grid-cols-2 gap-6">

                <div>
                  <label className="block mb-2 font-medium">
                    Event Name *
                  </label>

                  <input
                    type="text"
                    name="eventName"
                    value={formData.eventName}
                    onChange={handleChange}
                    required
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    Event Website
                  </label>

                  <input
                    type="url"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    Event Start Date *
                  </label>

                  <input
                    type="date"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleChange}
                    required
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    Event End Date *
                  </label>

                  <input
                    type="date"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleChange}
                    required
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

              </div>
            </div>

            <div className="mb-8">
              <h2 className="text-3xl font-display mb-6">
                Location
              </h2>

              <div className="grid md:grid-cols-3 gap-6">

                <div>
                  <label className="block mb-2 font-medium">
                    Venue Name
                  </label>

                  <input
                    type="text"
                    name="venue"
                    value={formData.venue}
                    onChange={handleChange}
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    City
                  </label>

                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

                <div>
                  <label className="block mb-2 font-medium">
                    State
                  </label>

                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    className="w-full border rounded-xl px-4 py-3"
                  />
                </div>

              </div>
            </div>

            <div className="space-y-4">

                <label className="flex gap-3 items-center">
                    <input
                    type="checkbox"
                    name="mangaLibrary"
                    checked={formData.mangaLibrary}
                    onChange={handleChange}
                    />
                    Traveling Manga Library
                </label>

                <label className="flex gap-3 items-center">
                    <input
                    type="checkbox"
                    name="arcadeMachines"
                    checked={formData.arcadeMachines}
                    onChange={handleChange}
                    />
                    Free Play Arcade Collection
                </label>

                <label className="flex gap-3 items-center">
                    <input
                    type="checkbox"
                    name="matsuriActivities"
                    checked={formData.matsuriActivities}
                    onChange={handleChange}
                    />
                    Matsuri Activities & Japanese Festival Games
                </label>

                <label className="flex gap-3 items-center">
                    <input
                    type="checkbox"
                    name="educationalPanels"
                    checked={formData.educationalPanels}
                    onChange={handleChange}
                    />
                    Educational Panels
                </label>

                <label className="flex gap-3 items-center">
                    <input
                    type="checkbox"
                    name="workshops"
                    checked={formData.workshops}
                    onChange={handleChange}
                    />
                    Hands-On Workshops
                </label>

                <label className="flex gap-3 items-center">
                    <input
                    type="checkbox"
                    name="tableRentals"
                    checked={formData.tableRentals}
                    onChange={handleChange}
                    />
                    Banquet Table Rentals
                </label>

                </div>

            <div className="my-8">
              <label className="block mb-2 font-medium">
                Estimated Attendance
              </label>

              <input
                type="number"
                name="attendance"
                value={formData.attendance}
                onChange={handleChange}
                className="w-full border rounded-xl px-4 py-3"
              />
            </div>

            <div className="mb-8">
              <label className="block mb-2 font-medium">
                Available Space
              </label>

              <input
                type="text"
                name="spaceAvailable"
                value={formData.spaceAvailable}
                onChange={handleChange}
                placeholder="Example: 40ft x 60ft"
                className="w-full border rounded-xl px-4 py-3"
              />
            </div>

            <div className="mb-8">
              <label className="block mb-2 font-medium">
                Additional Information
              </label>

              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                rows={8}
                className="w-full border rounded-xl px-4 py-3"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full md:w-auto px-10 py-4 rounded-xl bg-primary text-primary-foreground font-semibold"
            >
              {loading ? "Submitting..." : "Submit Request"}
            </button>

          </form>

        </div>
      </section>
    </main>
  );
};

export default EventSupportRequest;